export const SUPPORT_PATH = '/support' as const;
